import _slicedToArray from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useStyleRegister } from '@ant-design/cssinjs';
import { warning } from 'rc-util';
import { useContext } from 'react';
import { ConfigContext } from '../../config-provider/context';
import { genCommonStyle, genLinkStyle } from '../../style';
import useToken from '../useToken';
import statisticToken, { merge as mergeToken } from './statistic';
export default function genComponentStyleHook(component, styleFn, getDefaultToken, options) {
  return function (prefixCls) {
    var _useToken = useToken(),
        _useToken2 = _slicedToArray(_useToken, 3),
        theme = _useToken2[0],
        token = _useToken2[1],
        hashId = _useToken2[2];

    var _useContext = useContext(ConfigContext),
        getPrefixCls = _useContext.getPrefixCls,
        iconPrefixCls = _useContext.iconPrefixCls,
        csp = _useContext.csp;

    var rootPrefixCls = getPrefixCls(); // Shared config

    var sharedConfig = {
      theme: theme,
      token: token,
      hashId: hashId,
      nonce: function nonce() {
        return csp === null || csp === void 0 ? void 0 : csp.nonce;
      }
    }; // Generate style for all a tags in antd component.

    useStyleRegister(Object.assign(Object.assign({}, sharedConfig), {
      path: ['Shared', rootPrefixCls]
    }), function () {
      return [{
        // Link
        '&': genLinkStyle(token)
      }];
    });
    return [useStyleRegister(Object.assign(Object.assign({}, sharedConfig), {
      path: [component, prefixCls, iconPrefixCls]
    }), function () {
      var _statisticToken = statisticToken(token),
          proxyToken = _statisticToken.token,
          flush = _statisticToken.flush;

      var customComponentToken = Object.assign({}, token[component]);

      if (options === null || options === void 0 ? void 0 : options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              oldTokenKey = _ref2[0],
              newTokenKey = _ref2[1];

          var _a;

          if (process.env.NODE_ENV !== 'production') {
            process.env.NODE_ENV !== "production" ? warning(!(customComponentToken === null || customComponentToken === void 0 ? void 0 : customComponentToken[oldTokenKey]), "The token '".concat(String(oldTokenKey), "' of ").concat(component, " had deprecated, use '").concat(String(newTokenKey), "' instead.")) : void 0;
          } // Should wrap with `if` clause, or there will be `undefined` in object.


          if ((customComponentToken === null || customComponentToken === void 0 ? void 0 : customComponentToken[oldTokenKey]) || (customComponentToken === null || customComponentToken === void 0 ? void 0 : customComponentToken[newTokenKey])) {
            (_a = customComponentToken[newTokenKey]) !== null && _a !== void 0 ? _a : customComponentToken[newTokenKey] = customComponentToken === null || customComponentToken === void 0 ? void 0 : customComponentToken[oldTokenKey];
          }
        });
      }

      var defaultComponentToken = typeof getDefaultToken === 'function' ? getDefaultToken(mergeToken(proxyToken, customComponentToken !== null && customComponentToken !== void 0 ? customComponentToken : {})) : getDefaultToken;
      var mergedComponentToken = Object.assign(Object.assign({}, defaultComponentToken), customComponentToken);
      var componentCls = ".".concat(prefixCls);
      var mergedToken = mergeToken(proxyToken, {
        componentCls: componentCls,
        prefixCls: prefixCls,
        iconCls: ".".concat(iconPrefixCls),
        antCls: ".".concat(rootPrefixCls)
      }, mergedComponentToken);
      var styleInterpolation = styleFn(mergedToken, {
        hashId: hashId,
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        overrideComponentToken: customComponentToken
      });
      flush(component, mergedComponentToken);
      return [(options === null || options === void 0 ? void 0 : options.resetStyle) === false ? null : genCommonStyle(token, prefixCls), styleInterpolation];
    }), hashId];
  };
}